export const MORTGAGE_BROKER = {
  value: "mortgage_broker",
  name: "Mortgage Broker",
};

export const BORROWER = {
  value: "borrower_f_n_f",
  name: "Borrower",
};

export const REALTOR = {
  value: "realtor_listing",
  name: "Realtor",
};

const contact_id_status = [BORROWER, MORTGAGE_BROKER, REALTOR];

export default contact_id_status;



// WEBPACK FOOTER //
// ./src/constants/contact_id_status.js